import React, { useEffect, useRef, useState } from "react";

export default function AddFactoryPaymentMenu({
  onCreateFromAllocation,
  onCreateFromCompanyAccount,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-blue-700"
      >
        <span className="text-lg leading-none">＋</span>
        Сделать наш платёж фабрике
        <svg
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 z-30 mt-2 w-80 overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-xl">
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onCreateFromAllocation();
            }}
            className="block w-full px-4 py-3 text-left transition hover:bg-gray-50"
          >
            <span className="block text-sm font-semibold text-gray-900">
              Из нераспределённого назначения клиента
            </span>
            <span className="mt-0.5 block text-xs text-gray-500">
              Распределить остаток клиентского платежа
            </span>
          </button>

          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onCreateFromCompanyAccount();
            }}
            className="block w-full border-t border-gray-100 px-4 py-3 text-left transition hover:bg-gray-50"
          >
            <span className="block text-sm font-semibold text-gray-900">
              Со счёта компании
            </span>
            <span className="mt-0.5 block text-xs text-gray-500">
              Платёж фабрике за счёт компании
            </span>
          </button>
        </div>
      )}
    </div>
  );
}